


import {Component, Prop, Vue} from 'vue-property-decorator';
import MammadabaMap from '@/interfaces/geo/mammadaba-map.interface';

declare const GeoMammadabaMap: MammadabaMap;

@Component({})
export default class AppMiniMap extends Vue {

  @Prop()
  public url!: string | null;

  @Prop()
  public mapRendered: boolean = false;

  public mapContainerElement(): HTMLDivElement {
    return this.$refs.mapContainer as HTMLDivElement;
  }
}
